import React from 'react';
import {Trans} from 'react-i18next';
import {ISendPresentationsNotification, ISharePresentationsNotification} from '../../../incase-domain/notification';

interface IPresentationNotificationTextProps {
    notification: ISendPresentationsNotification | ISharePresentationsNotification;
    isShare?: boolean;
}

function PresentationNotificationText({notification, isShare}: IPresentationNotificationTextProps): JSX.Element | null {
    return (
        <Trans
            i18nKey={`${isShare ? 'notifications.sharePresentation.request' : 'notifications.sendPresentation.request'}`}
            components={{bold: <strong />}}
            values={{email: notification.senderEmail}}
        />
    );
}

export default PresentationNotificationText;
